export default __webpack_public_path__ + "static/media/uob.5d12c544.svg";